@if (alarms && alarms.alarms.length !== 0) {
  <div class="table-responsive">
    <table class="grayed-table table table-responsive table-striped table-borderless mb-0 w-100 d-block d-sm-table text-nowrap alarms-table">
      <thead>
        <tr>
          <th class="pr-1 pl-3 w-auto">
            <app-sort (sortChanged)="sortChanged($event, 'turbineCode')">{{"ALARMS.WIND_TURBINE" |translate}}
            </app-sort>
          </th>
          <th class="px-1 w-auto">
            <app-sort (sortChanged)="sortChanged($event, 'signalName')">{{"ALARMS.SIGNAL" |translate}}
            </app-sort>
          </th>
          <th class="px-1 w-auto">
            <app-sort (sortChanged)="sortChanged($event, 'temp')">{{"ALARMS.TEMPERATURE" |translate}}
            </app-sort>
          </th>
          <th class="px-1 w-auto">
            <app-sort (sortChanged)="sortChanged($event, 'trend')">{{"ALARMS.TREND" |translate}}
            </app-sort>
          </th>
          <th class="px-1 w-auto">
            <app-sort (sortChanged)="sortChanged($event, 'deviation')">{{"ALARMS.DEVIATION" |translate}}
            </app-sort>
          </th>
          <th class="pr-3 pl-1 w-auto">
            <app-sort (sortChanged)="sortChanged($event, 'detectionTS')">{{"ALARMS.DETECTED" |translate}}
            </app-sort>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (alarm of alarms.alarms; track alarm; let i = $index) {
          @if (!showAll ? (i < alarms.maxNumberOfRows) : (i < alarms.alarms.length)) {
            <tr>
              <td class="pr-1 pl-3 w-auto clickable">
                <a [routerLink]="['/monitor/turbine', alarm.turbineSerialNav,'1']" [queryParams]="{ alarms: 'cms', signal: alarm.signal }" [matTooltip]="alarm?.turbineSerial" class="font-weight-bold text-primary">
                  {{ alarm.turbineCode | noUnderscore }}
                </a>
              </td>
              <td class="px-1 w-auto text-center text-primary">
                <div>{{ alarm.signalName }}</div>
              </td>
              <td class="px-1 w-auto text-center text-primary">
                <div>{{ alarm.temp | number:'1.1-1' | customNumberFormat }}°C</div>
              </td>
              <td class="px-1 w-auto text-center text-primary">
                <div>
                  @if (alarm.trend === 'new' || alarm.trend === 'closed') {
                    <div
                    [style.color]="alarm.trend === 'new' ? '#DF000F' : 'var(--primary)' ">{{ alarm.trend | capitalizeFirst }}</div>
                  }
                  @if (alarm.trend !== 'new' && alarm.trend !== 'closed') {
                    <div class="trend {{alarm.trend}}"></div>
                  }
                </div>
              </td>
              <td class="px-1 w-auto text-center text-primary">
                <div>+{{ alarm.deviation | number:'1.1-1' | customNumberFormat }}%</div>
              </td>
              <td class="pr-3 pl-1 w-auto text-center text-primary">
                <div>{{ alarm.detectionTS | dateTimeFormatPipe: 'dmt':tz.selectedOption}}</div>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
    @if (alarms.maxNumberOfRows < alarms.alarms.length) {
      <app-show-all [numberOfElements]="alarms.alarms.length"
      (changed)="toggleShowAll($event)"></app-show-all>
    }
  </div>
}

@if (alarms && alarms.alarms.length === 0) {
  <div class="row">
    <div class="col p-3 text-center">{{"ALARMS.NO_ALARMS" |translate}}</div>
  </div>
}
